import moment from 'moment';
import React from 'react';
import { getFullName } from '../../../utils';
import { updateActiveStatusOfGroup } from '../../../services/apiService';
import { styledDefaultColDef, createAvatarNameRenderer } from '../../../extras/cellRenderers';

const CompanyAvatarRenderer = createAvatarNameRenderer(
  (p) => p.data?.companyDetails?.companyName,
  () => ''
);

function CompanyNameGetter(params) {
  return (
    <div
      style={{ display: 'flex', alignItems: 'center', height: '100%', cursor: 'pointer' }}
      onClick={() => {
        const win = window.open(
          `/job-dashboardv2/update-job-group/${params.data?.groupId}`,
          '_blank'
        );
        win.focus();
      }}
    >
      <CompanyAvatarRenderer {...params} />
    </div>
  );
}
function JobTitleGetter(params) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
      <span style={{ fontSize: 13, color: '#374151' }}>
        {params.data?.jobTitleDetails?.title || '—'}
      </span>
    </div>
  );
}
function StudentsGetter(params) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
      <span style={{ fontSize: 13, color: '#374151' }}>
        {params.data?.studentsCount ?? 0}
      </span>
    </div>
  );
}

function RegDateGetter(params) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
      <span style={{ fontSize: 11.5, color: '#9CA3AF' }}>
        {moment(params.data?.createdAt).utc().fromNow()}
      </span>
    </div>
  );
}
function RegDateGetterForLastGroupActivity(params) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
      <span style={{ fontSize: 11.5, color: '#9CA3AF' }}>
        {moment(params.data?.lastGroupActivity).utc().fromNow()}
      </span>
    </div>
  );
}

// function ProgressLevelRenderer(params) {
//   return (
//     <div className='relative flex-col items-center justify-center ml-10 top-2'>
//       <div className='flex justify-center text-base'>
//         {/* <div className='text-base'>
//         {console.log("lastActivity:------",params.data?.lastGroupActivity)}
//           {moment(params.data?.lastGroupActivity).utc().format('DD/MM/YYYY')}
//         </div> */}

//         <div className='ml-2 text-sm text-gray-400 '>
//           {params.data?.highestProgressLevel}%
//         </div>
//       </div>
//     </div>
//   );
// }

function StatusGetter(params) {
  return (
    <div className='flex items-center justify-center '>
      <span className='flex-auto px-2 py-1 font-semibold text-center rounded '>
        {params.data?.status}
      </span>
    </div>
  );
}
function SpockGetter(params) {
  return (
    <div className='flex items-center'>
      <span className='px-2 py-1 text-center rounded'>
        {getFullName(params.data?.placementSpocDetails ?? {})}
      </span>
    </div>
  );
}

function ActivityStatus(params) {
  const [isChecked, setIsChecked] = React.useState(params.data?.activeStatus);

  const updateActiveStatus = async (status) => {
    try {
      const response = await updateActiveStatusOfGroup({
        groupId: params.data.groupId,
        updatedActiveStatus: status,
      });
      if (
        response.message === 'Job Group Active Status Updtated Successfully.'
      ) {
        return 'success';
      }
    } catch (error) {
      console.log({ error });
      return null;
    }
  };

  return (
    <div className='flex items-center justify-center'>
      <label className='cursor-pointer'>
        <input
          type='checkbox'
          checked={isChecked}
          onChange={(e) => {
            if (updateActiveStatus(e.target.checked))
              setIsChecked(e.target.checked);
          }}
        />
        <span className='ml-2'>Active</span>
      </label>
    </div>
  );
}

export const columnDefs = [
  {
    headerName: 'Company',
    field: 'company',
    filter: 'agTextColumnFilter',
    width: 200,
    resizable: false,
    sortable: false,
    filterParams: {
      filterOptions: ['contains'],
      valueGetter: (props) => {
        return props.data?.companyDetails?.companyName;
      },
      debounceMs: 200,
    },
    comparator: (valueA, valueB, nodeA, nodeB, isDescending) => {
      const nameA = nodeA.data?.companyDetails?.companyName;
      const nameB = nodeB.data?.companyDetails?.companyName;
      const comparison = nameA.localeCompare(nameB);
      return comparison;
    },
    cellRenderer: CompanyNameGetter,
  },
  {
    headerName: 'Job Title',
    field: 'jobTitle',
    filter: 'agTextColumnFilter',
    comparator: (valueA, valueB, nodeA, nodeB, isDescending) => {
      const nameA = nodeA.data?.jobTitleDetails?.title;
      const nameB = nodeB.data?.jobTitleDetails?.title;
      const comparison = nameA.localeCompare(nameB);
      return comparison;
    },
    cellRenderer: JobTitleGetter,
  },

  {
    headerName: 'Last Activity',
    field: 'lastGroupActivity',
    sort: 'desc',
    sortable: true,
    filter: 'agDateColumnFilter',
    sortingOrder: ['desc', 'asc'],
    // filterParams: {
    //   valueGetter: (props) => moment(props.data?.updatedAt),
    //   debounceMs: 200,
    //   comparator: (filterLocalDateAtMidnight, cellValue) => {
    //     const dateAsString = moment(cellValue).format('DD/MM/YYYY');
    //     if (dateAsString == null) {
    //       return 0;
    //     }
    //     const dateParts = dateAsString.split('/');
    //     const year = Number(dateParts[2]);
    //     const month = Number(dateParts[1]) - 1;
    //     const day = Number(dateParts[0]);
    //     const cellDate = new Date(year, month, day);

    //     if (cellDate < filterLocalDateAtMidnight) {
    //       return -1;
    //     } else if (cellDate > filterLocalDateAtMidnight) {
    //       return 1;
    //     }
    //     return 0;
    //   },
    // },
    // comparator: (valueA, valueB, nodeA, nodeB, isDescending) => {
    //   const dateA = moment(nodeA.data?.createdAt);
    //   const dateB = moment(nodeB.data?.createdAt);
    //   const comparison = dateA.diff(dateB);
    //   return comparison;
    // },
    cellRenderer: RegDateGetterForLastGroupActivity,
  },
  // {
  //   headerName: 'Progress',
  //   field: 'highestProgressLevel',
  //   sortable: true,
  //   filter: 'agDateColumnFilter',
  //   cellRenderer: ProgressLevelRenderer,
  // },
  {
    headerName: 'Students',
    field: 'studentsCount',
    resizable: true,
    sortable: true,
    filterParams: {
      filterOptions: ['contains'],
      valueGetter: (props) => {
        return props.data?.studentsCount;
      },
      debounceMs: 200,
    },
    cellRenderer: StudentsGetter,
  },
  {
    headerName: 'Created At',
    field: 'createdAt',
    // sort: 'desc',
    sortable: true,
    filter: 'agDateColumnFilter',
    // sortingOrder: ['desc', 'asc'],
    // filterParams: {
    //   valueGetter: (props) => moment(props.data?.updatedAt),
    //   debounceMs: 200,
    //   comparator: (filterLocalDateAtMidnight, cellValue) => {
    //     const dateAsString = moment(cellValue).format('DD/MM/YYYY');
    //     if (dateAsString == null) {
    //       return 0;
    //     }
    //     const dateParts = dateAsString.split('/');
    //     const year = Number(dateParts[2]);
    //     const month = Number(dateParts[1]) - 1;
    //     const day = Number(dateParts[0]);
    //     const cellDate = new Date(year, month, day);

    //     if (cellDate < filterLocalDateAtMidnight) {
    //       return -1;
    //     } else if (cellDate > filterLocalDateAtMidnight) {
    //       return 1;
    //     }
    //     return 0;
    //   },
    // },
    // comparator: (valueA, valueB, nodeA, nodeB, isDescending) => {
    //   const dateA = moment(nodeA.data?.createdAt);
    //   const dateB = moment(nodeB.data?.createdAt);
    //   const comparison = dateA.diff(dateB);
    //   return comparison;
    // },
    cellRenderer: RegDateGetter,
  },
  {
    headerName: 'Status',
    field: 'status',
    resizable: true,
    width: 150,
    cellRenderer: StatusGetter,
  },
  {
    headerName: 'Placement Spoc',
    field: 'placementSpock',
    resizable: true,
    cellRenderer: SpockGetter,
  },
  {
    headerName: 'Activity Status',
    field: 'activeStatus', // change this to activity status once activity status field is added
    resizable: true,
    // editable: true,
    cellRenderer: ActivityStatus,
  },
  // {
  //   headerName: 'Actions',
  //   field: 'actions',
  //   cellRenderer: 'btnCellRenderer',
  //   sortable: false,
  //   resizable: true,
  //   suppressMenu: true,
  // },
];

export const defaultColDef = {
  ...styledDefaultColDef,
  filter: true,
};
